import InfoService from "../services/info.service";
// import authHeader from "../services/auth-header";

const initialState = { labels: {} };

console.log({ initialState });
export const settings = {
  namespaced: true,
  state: initialState,
  actions: {
    async getLabels({ commit }) {
      const res = await InfoService.getLabels();
      commit("setLabels", res.data);
    },
  },
  mutations: {
    setLabels(state, value) {
      state.labels = value;
    },
  },
  getters: {
    labels: state => {
      return state.labels;
    },
  },
};

(async function() {
  try {
    console.log("store settings.module.js");
    const res = await InfoService.getInfoLabels();
    console.log(res.data);
    settings.state.labels = res.data;
  } catch (error) {
    console.log(error);
  }
})();
